// PostDraftList.jsx
import React from 'react';
import PropTypes from 'prop-types';

import PostDraftItem from '../container/PostDraftItem.js';

export const PostDraftList = ({ uploadJobIds }) => {
  return uploadJobIds
    .sort(() => -1)
    .map(id => {
      return <PostDraftItem key={id} uploadJobId={id} />;
    });
};

PostDraftList.propTypes = {
  uploadJobIds: PropTypes.array,
};

PostDraftList.defaultProps = {
  uploadJobIds: [],
};

export default PostDraftList;
